import React from 'react';
import Utils from '../../providers/Utils';
import avatar from '../../Pics/avatar.jpg'
import Ws from '../../providers/Ws';
import { FormControl, InputLabel, Select, Input, MenuItem, Button, Grid } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import html2canvas from 'html2canvas'

export default class FoaieColectiva extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listDaysOfWeek:
                [
                    {
                        name: 'lu',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'ma',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'mi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'jo',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'vi',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'white',
                        pontajList: []
                    },
                    {
                        name: 'sa',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    },
                    {
                        name: 'du',
                        date: '',
                        selectedDay: false,
                        backgroundColor: 'rgba(202, 202, 202, 0.63)',
                        pontajList: []
                    }

                ],


        }
    }


    u = new Utils();

    componentDidMount() {

        console.log('this.props.departament :>> ', this.props.departament);
    }

    numeLuna = (l) => {

        console.log('l :', l);
        let rez = ''

        switch (l) {
            case 1: rez = this.dictionary.luni.ianuarie; break;
            case 2: rez = this.dictionary.luni.februarie; break;
            case 3: rez = this.dictionary.luni.martie; break;
            case 4: rez = this.dictionary.luni.aprilie; break;
            case 5: rez = this.dictionary.luni.mai; break;
            case 6: rez = this.dictionary.luni.iunie; break;
            case 7: rez = this.dictionary.luni.iulie; break;
            case 8: rez = this.dictionary.luni.august; break;
            case 9: rez = this.dictionary.luni.septembrie; break;
            case 10: rez = this.dictionary.luni.octombrie; break;
            case 11: rez = this.dictionary.luni.noiembrie; break;
            case 12: rez = this.dictionary.luni.decembrie; break;

        }

        return rez
    }







    getProgramatorInfo = () => {




        let angajati = [...this.props.angajati]
        let pontaje = [...this.props.pontajeAll]

        // console.log('pontaje all :', pontaje);



        let u = new Utils();

        let nrOfDaysInMonth = u.getDaysInMonth(new Date(this.props.dataStart).getFullYear(), new Date(this.props.dataStart).getMonth() + 1)

        let dataSelected = new Date().setFullYear(new Date(this.props.dataStart).getFullYear())
        dataSelected = new Date(dataSelected).setMonth(new Date(this.props.dataStart).getMonth() + 1 - 1)

        // console.warn('nrOfDaysInMonth :', nrOfDaysInMonth);

        let tableHead = []

        let tH = []

        let table = []

        let tBody = []


        //console.log('angajati :', angajati);



        for (let i = -1, n = angajati.length; i < n; i++) {
            let tr = []
            let oreTotal = 0
            let oreSuplimentare = 0
            for (let j = 0; j < nrOfDaysInMonth; j++) {
                let date = new Date(dataSelected).setDate(j)
                if (i === -1) {

                    tH.push(<th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} key={`th${j}`}>{j + 1} </th>)

                } else {
                    let dataCalendar = u.transformDataForSql(new Date(dataSelected).setDate(j + 1));

                    let filterPontaje = pontaje.filter(p => p.id_angajat === angajati[i].id)



                    console.log('dataCalendar :', dataCalendar);

                    let idx = filterPontaje.findIndex(p => u.ParseDataFromSql(p.cand_inceput_dataC) <= dataCalendar && u.ParseDataFromSql(p.cand_sfarsit_dataC) >= dataCalendar)

                    let filterPrezenta = filterPontaje.filter(p => p.prezent_azi === 1)



                    console.log('filterPrezenta :>> ', filterPrezenta);




                    if (idx === -1) {


                        let idx2 = filterPrezenta.findIndex(p => u.ParseDataFromSql(p.la_data) === dataCalendar)


                        if (idx2 !== -1) {

                            console.log('filterPrezenta[idx2] :>> ', filterPrezenta[idx2]);


                            if (filterPrezenta[idx2].tip_concediu === 'ore_suplimentare') {
                                console.log('angajati[i] :>> ', angajati[i]);
                                console.log('filterPrezenta[idx2] :>> ', filterPrezenta[idx2]);

                                if (angajati[i].program[new Date(date).getDay()]) {
                                    oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) + this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)

                                    oreSuplimentare += this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)

                                    tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>{this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) + this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)}</td>)

                                } else {
                                    oreSuplimentare += this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)
                                    tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>{this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)}</td>)

                                }


                            } else {

                                filterPrezenta[idx2].nr_ore_lucrate = this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)

                                oreTotal += filterPrezenta[idx2].nr_ore_lucrate

                                tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>{filterPrezenta[idx2].nr_ore_lucrate}</td>)
                            }


                        } else if (idx2 === -1 && (new Date(date) < new Date()) && new Date(date).getDay() !== 5 && new Date(date).getDay() !== 6) {

                            let pontajAzi = filterPontaje.findIndex(pt => u.ParseDataFromSql(pt.la_data) === dataCalendar)

                            if (pontajAzi !== -1) {
                                console.log('filterPontaje :>> ', filterPontaje[pontajAzi]);
                                console.log('angajati[i] :>> ', angajati[i]);

                                console.log('angajati[i].program[new Date(date).getDay()] :>> ', angajati[i].program);
                                // console.log('pontajAziOreSuplimentare :>> ', filterPontaje[pontajAzi]);
                                // console.log('new Date(date).getDay() :>> ', new Date(date).getDay());


                                if (angajati[i].program[new Date(date).getDay()] && angajati[i].program[new Date(date).getDay()] > 0) {

                                    // console.log('oreSuplimentare :>> ', filterPontaje[pontajAzi]);



                                    if (filterPontaje[pontajAzi].tip_concediu !== 'ore_suplimentare') {
                                        console.log('oreSuplimentare :>> ', filterPontaje[pontajAzi]);

                                        if (filterPontaje[pontajAzi].tip_concediu === "invoire") {
                                            oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) - this.u.hourDifferenceInHours(filterPrezenta[idx2].cand_inceput_oraC, filterPrezenta[idx2].cand_sfarsit_oraC)

                                            tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>AI</td>)
                                        } else {
                                            oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) - this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)

                                            tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>{this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) - this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)}</td>)

                                        }

                                    }

                                    else {

                                        console.log('oreSuplimentare :>> ', filterPontaje[pontajAzi]);
                                        oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) + this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)

                                        oreSuplimentare += this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)

                                        tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>{this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) + this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)}</td>)

                                    }


                                } else if (filterPontaje[pontajAzi].tip_concediu === "absenta_invoire") {
                                    console.log('filterPontaje[pontajAzi] :>> ', filterPontaje[pontajAzi]);
                                    if (angajati[i].program[new Date(date).getDay()]) {
                                        oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end)
                                    }
                                    // console.log('oreSuplimentare :>> ', filterPontaje[pontajAzi]);
                                    tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>AI</td>)

                                }


                                else {

                                    if (filterPontaje[pontajAzi].tip_concediu === "invoire") {
                                        if (angajati[i].program[new Date(date).getDay()]) {
                                            oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end) - this.u.hourDifferenceInHours(filterPontaje[pontajAzi].cand_inceput_oraC, filterPontaje[pontajAzi].cand_sfarsit_oraC)
                                        }

                                        tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>AI</td>)
                                    } else {

                                        tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>AN</td>)
                                    }
                                }



                            } else {
                                tr.push(<td style={{ border: '1px solid #d8d4d4', }} key={`td${angajati[i].id}${j}`}>AN</td>)
                            }


                            // let tipConcedii = u.tipConcedii
                            // let idxC = tipConcedii.findIndex(t => t.id === filterPontaje[idx].tip_concediu)


                            // if (idxC !== -1) {
                            //     console.log('filterPontaje[idx] :>> ', filterPontaje[idx]);

                            // }




                        }

                        else {
                            tr.push(<td style={{ border: '1px solid #d8d4d4', backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].backgroundColor, color: '#72816e' }} key={`td${angajati[i].id}${j}`}></td>)

                        }



                    } else {

                        let tipConcedii = u.tipConcedii
                        console.log('filterPontaje[idx].tip_concediu :>> ', filterPontaje);
                        console.log('tipConcedii :>> ', tipConcedii);

                        let idxC = tipConcedii.findIndex(t => t.id === filterPontaje[idx].tip_concediu)
                        if (idxC !== -1) {

                            console.log('tipConcedii :>> ', tipConcedii);

                            if (tipConcedii[idxC].id === 'concediu_odihna' || tipConcedii[idxC].id === "concediu_medical" || tipConcedii[idxC].id === "concediu_ingrijire_copil") {

                                console.log('angajati[i] :>> ', angajati[i]);
                                tr.push(<td onClick={() => { this.props.editConcediu(filterPontaje[idx], tipConcedii[idxC]) }} style={{ border: '1px solid #d8d4d4', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>{tipConcedii[idxC].alias}</td>)


                            } else if (tipConcedii[idxC].id === 'preaviz') {
                                if (angajati[i].program[new Date(date).getDay()]) {

                                    oreTotal += this.u.hourDifferenceInHours(angajati[i].program[new Date(date).getDay()].start, angajati[i].program[new Date(date).getDay()].end)
                                }

                                tr.push(<td onClick={() => { this.props.editConcediu(filterPontaje[idx], tipConcedii[idxC]) }} style={{ border: '1px solid #d8d4d4', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>{tipConcedii[idxC].alias}</td>)
                            }else{
                                tr.push(<td onClick={() => { this.props.editConcediu(filterPontaje[idx], tipConcedii[idxC]) }} style={{ border: '1px solid #d8d4d4', cursor: 'pointer' }} key={`td${angajati[i].id}${j}`}>{tipConcedii[idxC].alias}</td>)

                            }

                        } else {

                            tr.push(<td style={{ border: '1px solid #d8d4d4', backgroundColor: this.state.listDaysOfWeek[new Date(date).getDay()].backgroundColor, color: '#72816e' }} key={`td${angajati[i].id}${j}`}></td>)
                        }

                    }





                    // if (idx !== -1) {

                    //     console.log('filterPontaje :', filterPontaje[idx]);

                    //     if (filterPontaje[idx].prezenta > 0) {

                    //         tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: '#0da20dbd', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    //     } else {
                    //         tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: 'orange', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    //     }
                    // } else {
                    //     tr.push(<td key={`td${angajati[i].id}${j}`} style={{ backgroundColor: (new Date(dataCalendar).getDay() === 6 || new Date(dataCalendar).getDay() === 0) ? 'rgba(202, 202, 202, 0.63)' : '#d8101080', color: 'white', textAlign: 'center', border: '1px solid #d8d4d4' }}>{j + 1}</td>)
                    // }
                }
            }



            if (i !== -1) {
                tr = (<tr key={`tr${angajati[i].id}`}>
                    <td style={{ border: '1px solid #d8d4d4' }}  >
                        {angajati[i].nume}


                    </td>
                    <td style={{ border: '1px solid #d8d4d4' }}  >
                        {angajati[i].functie || ''}


                    </td>
                    {tr}
                    <td key={`tdtotal`} style={{ textAlign: 'center', verticalAlign: 'unset', border: '1px solid #d8d4d4' }}> {oreTotal}</td>
                    <td key={`tdSuplimentare`} style={{ textAlign: 'center', verticalAlign: 'unset', border: '1px solid #d8d4d4' }}> {oreSuplimentare}</td>
                </tr>)

                tBody.push(tr)

            }





        }



        tableHead = (

            <tr style={{ height: 75, fontWeight: 400 }}>


                {tH}


                <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }}  >

                    <div style={{ transform: 'rotate(90deg)', fontWeight: 400 }}>
                        Ore Suplimentare
                    </div>
                </th>
            </tr>
        )



        table = (


            <table style={{ marginBottom: 0, width: '98%', margin: '0 auto', borderCollapse: 'collapse', backgroundColor: 'white', fontSize: 9 }}>
                <tbody>
                    <tr>
                        <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} rowSpan={2} >
                            Numele si prenumele
                        </th>
                        <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} rowSpan={2} >

                            <div style={{ transform: 'rotate(90deg)', fontWeight: 400 }}>
                                Functia
                            </div>

                        </th>
                        <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} colSpan={nrOfDaysInMonth}>ORE ZILNIC</th>
                        <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} rowSpan={2} >

                            <div style={{ transform: 'rotate(90deg)', fontWeight: 400 }}>
                                Total ore lucrate
                            </div>
                        </th>
                        <th style={{ border: '1px solid #d8d4d4', fontWeight: 400 }} >Din Care</th>


                    </tr>
                    {tableHead}
                    {tBody}
                </tbody>
            </table>
            // {/* <div className='body'>

            //     <table style={{ width: '95%', minWidth: 1200, maxWidth: 1300, margin: '0 auto', tableLayout: 'fixed', borderCollapse: 'collapse', backgroundColor: 'white', position: 'relative' }}>
            //         <tbody>{tBody}</tbody>
            //     </table>
            //         <div style={{ textAlign: 'left', marginTop: 10, width: '95%', margin: '0 auto', maxWidth: 1300 }}>
            //             {this.props.tipConcedii.map((c, idx) => {
            //                 return (
            //                     <div key={idx} style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
            //                         <div style={{ backgroundColor: c.bkColor, verticalAlign: 'bottom', borderRadius: 10, height: 17, width: 35 }} className='pm-task-legend'></div>
            //                         <span className='pm-title'>{c.nume}</span>
            //                     </div>
            //                 )
            //             })}

            //             <div  style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
            //                 <div style={{ backgroundColor:'rgb(20, 149, 20)' , verticalAlign: 'bottom', borderRadius: 10, height: 17, width: 35 }} className='pm-task-legend'></div>
            //                 <span className='pm-title'>Prezent</span>
            //             </div>

            //             <div  style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
            //                 <div style={{ backgroundColor:'rgb(193, 69, 23)' , verticalAlign: 'bottom', borderRadius: 10, height: 17, width: 35 }} className='pm-task-legend'></div>
            //                 <span className='pm-title'>Absenta nemotivata</span>
            //             </div>

            //         </div>

            // </div> */}

        )

        return table

    }

    print = () => {
        let doc = document.getElementById("doc_to_print")

        // console.log('doc :', doc.innerHTML);

        let mywindow = window.open('', 'PRINT', 'height=400 , width=600');

        mywindow.document.write(doc.innerHTML)

        mywindow.document.close();
        mywindow.focus();

        mywindow.print();
        mywindow.close();

        return true;

    }

    pictureToCanvas = async (id) => {

        // console.log('id :>> ', id);




        html2canvas(document.getElementById(id), {

            useCORS: true,
            width: document.getElementById(id).offsetWidth + 1000,
            height: document.getElementById(id).clientHeight + 1000,
            // windowWidth:document.getElementById(id).offsetWidth,
            windowHeight: document.getElementById(id).scrollHeight + 1000,
            x: 0,
            y: window.pageYOffset
        }).then(async (canvas) => {



            let img = canvas.toDataURL("image/png")

            console.log('canvas :>> ', canvas);
            let link = document.createElement('a');
            link.download = 'file.png'
            link.href = img
            link.click()


            let file = await fetch(img)

            let myFile;

            let idEv = this.props.ideval

            if (file.ok) {
                let res = await file.blob()

                if (res) {
                    myFile = new File([res], "NewCanvas", { type: res.type })
                }
            }





        });

        document.getElementById(id).style.width = '100%'
    }
    render() {
        return (
            <div >
                {/* <div className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_back</i>
                    <span style={{ fontSize: 20 }} className='monthcalendar-title'>{this.numeLuna(new Date(this.props.dataStart).getMonth() + 1)} - {new Date(this.props.dataStart).getFullYear()}</span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ color: 'rgb(117, 234, 117)', verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>arrow_forward</i>
                </div> */}


                <div style={{ marginTop: 20, textAlign: 'right' }} className='monthcalendar-header'>
                    <i onClick={this.props.minusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_left</i>
                    <span style={{ fontSize: 16, verticalAlign: 'text-bottom', textTransform: 'uppercase' }} className='monthcalendar-title'>
                        {this.numeLuna(new Date(this.props.dataStart).getMonth() + 1)} {new Date(this.props.dataStart).getFullYear()}

                    </span>
                    <i onClick={this.props.plusLuna} className='material-icons' style={{ verticalAlign: 'sub', cursor: 'pointer', fontSize: 20 }}>keyboard_arrow_right</i>
                </div>

                <div style={{ textAlign: 'right', width: 842, margin: 'auto' }}>
                    <Button className='add-button-green' style={{ marginRight: 10 }} onClick={this.print}>
                        <i className='material-icons'>local_printshop</i>  Print
                    </Button>

                    <Button className='add-button-green' onClick={() => { this.pictureToCanvas('doc_to_print') }}  >
                        Exporta Foaie Colectiva
                    </Button>
                </div>


                <div id="doc_to_print" style={{ width: '100%', margin: 'auto', }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{ textAlign: 'left', width: '100%' }}>
                            <h6 style={{ marginTop: 0 }}>Departament: {this.props.departament !== -1 ? this.props.departamente[this.props.departamente.findIndex(dp => dp.id === Number(this.props.departament))].nume : 'Toate'}</h6>
                        </div>
                        <div style={{ width: '100%', textAlign: 'center' }} >
                            <h3 style={{ marginTop: 20, }}> Foaie colectiva de prezenta</h3>
                            <h5 >pe luna {this.numeLuna(new Date(this.props.dataStart).getMonth() + 1)} {new Date(this.props.dataStart).getFullYear()} </h5>
                        </div>
                        <div style={{ fontSize: 10, textAlign: 'left', width: '100%' }}>
                            <div >
                                <span>Co - Concediu de odihna </span>  <span style={{ marginLeft: 5 }}> CM - Concediu medical</span>
                            </div>

                            <div>
                                <span>CI - Concediu ingrijire copil </span>  <span style={{ marginLeft: 5 }}> ES - Evenimente speciale</span>
                            </div>

                            <div>
                                <span>PR - Preaviz </span>  <span style={{ marginLeft: 5 }}> AI - Absenta Invoire</span>
                            </div>

                            <div>
                                <span>CFP - Concediu fara plata </span> <span>AN - Absenta nemotivata </span>
                            </div>

                          



                        </div>

                    </div>







                    {this.getProgramatorInfo()}

                </div>

            </div>
        );
    }
}